import { render, staticRenderFns } from "./userBindList.vue?vue&type=template&id=f35ed64a&scoped=true&"
import script from "./userBindList.vue?vue&type=script&lang=js&"
export * from "./userBindList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35ed64a",
  null
  
)

export default component.exports